module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-paper', {
    staticClass: "insetGraph"
  }, [_c('mu-row', {
    staticClass: "headingRow"
  }, [_c('mu-col', {
    staticClass: "deviceHeading",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "75"
    }
  }, [(_vm.service != 'LCP') ? _c('mu-row', [(_vm.service != 'LCP') ? _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subtractDay.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "70",
      "tablet": "70",
      "desktop": "70"
    }
  }, [_c('span', {
    staticClass: "mediumTitle",
    domProps: {
      "textContent": _vm._s(_vm.humanizeDate)
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right",
      "disabled": _vm.isToday
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDay.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "25"
    }
  }, [_c('service-tracking-types', {
    attrs: {
      "type": "sleep"
    }
  })], 1)], 1), _vm._v(" "), (_vm.$store.state.user.scope && _vm.service === 'LCP') ? _c('sleep-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'FITBIT') ? _c('fitbit-sleep-graph', {
    attrs: {
      "fitbitData": _vm.fitbitData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'STRIIV') ? _c('striiv-sleep-graph', {
    attrs: {
      "striivData": _vm.striivData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading && _vm.service != 'LCP') ? _c('mu-card', {
    staticClass: "card-spacing",
    staticStyle: {
      "min-height": "430px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_vm._v("\n\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n\n        "), _c('mu-circular-progress')], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticStyle: {
      "padding-top": "24px"
    },
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [(_vm.isLoading && _vm.service != 'LCP') ? _c('mu-card', {
    staticClass: "card-spacing",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', [_c('mu-circular-progress')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'STRIIV') ? _c('striiv-sleep-stages', {
    staticClass: "card-spacing",
    attrs: {
      "striivData": _vm.striivData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.service === 'FITBIT') ? _c('fitbit-sleep-stages', {
    staticClass: "card-spacing",
    attrs: {
      "fitbitData": _vm.fitbitData,
      "date": _vm.humanizeDate
    }
  }) : _vm._e(), _vm._v(" "), _c('sleep-input', {
    staticClass: "card-spacing"
  }), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "sleep"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "DEVICE"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'DEVICE'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelFromDevice').charAt(0).toUpperCase() + _vm.$t('message.labelFromDevice').substr(1)))]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "SELF_REPORTED"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mode = 'SELF_REPORTED'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelManualEntry')))])], 1), _vm._v(" "), _c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'title-index-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.btnColor,
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [(!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardSleepQuality')) + ": " + _vm._s(item.quality) + "/10")])]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [_vm._v("\n                        " + _vm._s(_vm.humanizedHours(item.hours)) + "\n                      ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('sleep-edit', {
        attrs: {
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()])], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80931672","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tracking/Sleep.vue
// module id = 3809
// module chunks = 1